// extracted by mini-css-extract-plugin
module.exports = {"imageSmile":"MyReviews_imageSmile__29w_g","heading":"MyReviews_heading__1H3jy"};